import { useState, useEffect } from "react";
import {
  Box,
  InputBase,
  Typography,
  Button,
  Dialog,
  DialogContent,
  TextField,
  Tooltip,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseSupplierOrder } from "./UseSupplierOrder";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import OrderDetail from "./OrderDetail";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import WarehouseIcon from "@mui/icons-material/Warehouse";

export default function SupplierOrders() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    getOrderList,
    validateEdit,
    cancelOrder,
    updateOrderWarehouse,
    updateOrder,
    getOrderByID,
  } = UseSupplierOrder();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [showAdd, setShowAdd] = useState(false);
  const [open, setOpen] = useState({ show: false, id: undefined });
  const [supplierRes, setOrderRes] = useState();
  const [openWarehouse, setOpenWarehouse] = useState(false);
  const [stateWarehouse, setStateWarehouse] = useState({
    ID: undefined,
    Warehouse: false,
    WarehouseDescription: undefined,
  });
  const [state, setState] = useState({
    ID: undefined,
    productCount: undefined,
    description: undefined,
  });
  const [errorState, setErrorState] = useState({
    productCount: false,
  });
  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getOrderList(
      myPc,
      search,
      (supplierorder) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(supplierorder.pageCondition.totalPage);
          return;
        }
        setOrderRes(supplierorder);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/supplierorders/addOrder", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "productID",
      headerName: "کد محصول",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productID}
          </Typography>
        );
      },
    },

    {
      field: "product",
      headerName: "محصول",
      width: 230,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.product}
          </Typography>
        );
      },
    },
    {
      field: "supplier",
      headerName: "تامین کننده",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.supplier}
          </Typography>
        );
      },
    },
    {
      field: "productCount",
      headerName: "تعداد سفارش",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productCount
              ? toMoney(cellValues.row.productCount)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "shamsiLogdate",
      headerName: " درخواست",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiLogdate ? cellValues.row.shamsiLogdate : "--"}
          </Typography>
        );
      },
    },
    {
      field: "shamsiVisitorLogdate",
      headerName: " بررسی",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiVisitorLogdate
              ? cellValues.row.shamsiVisitorLogdate
              : "--"}
          </Typography>
        );
      },
    },
    {
      field: "shamsiWarehouseLogdate",
      headerName: "تحویل انباردار",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiWarehouseLogdate
              ? cellValues.row.shamsiWarehouseLogdate
              : "--"}
          </Typography>
        );
      },
    },
    {
      field: "stateTitle",
      headerName: "وضعیت",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.stateTitle}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 300,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              color="error"
              variant="contained"
              disabled={cellValues.row.state !== 1}
              onClick={() => {
                setDeleteState({
                  show: true,
                  name: "",
                  id: cellValues.row.id,
                });
              }}
            >
              حذف
            </Button>
            <Button
              color="secondary"
              variant="outlined"
              // disabled={cellValues.row.state !== 1}
              onClick={() => {
                setProgress(true);
                getOrderByID(cellValues.row.id, (supplierRes) => {
                  setShowAdd(true);
                  setState({
                    ID: supplierRes.id,
                    productCount: supplierRes.productCount,
                    description: supplierRes.description,
                  });
                });
              }}
            >
              ویرایش
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => {
                setOpen({ show: true, id: cellValues.row.id });
              }}
            >
              جزئیات
            </Button>
            <Button
              color="info"
              variant="contained"
              disabled={cellValues.row.state == 1}
              onClick={() => {
                setProgress(true);
                getOrderByID(cellValues.row.id, (supplierRes) => {
                  setOpenWarehouse(true);
                  setStateWarehouse({
                    ID: supplierRes.id,
                    Warehouse: supplierRes.state == 3 ? true : false,
                    WarehouseDescription: supplierRes.warehouseDescription,
                  });
                });
              }}
            >
              انبار
            </Button>
          </Box>
        );
      },
    },
  ];
  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [{ name: msActiveMenu.pageTitle, url: "/supplierorder" }],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="xs"
        open={openWarehouse}
        onClose={() => setOpenWarehouse(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <FormControlLabel
              checked={stateWarehouse.Warehouse}
              onChange={(evt) => {
                setStateWarehouse({
                  ...stateWarehouse,
                  Warehouse: evt.target.checked,
                });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="تحویل انباردار شد"
            />
            <TextField
              label="توضیحات انباردار"
              multiline
              rows={3}
              value={
                stateWarehouse.WarehouseDescription
                  ? stateWarehouse.WarehouseDescription
                  : ""
              }
              onChange={(evt) => {
                setStateWarehouse({
                  ...stateWarehouse,
                  WarehouseDescription: evt.target.value,
                });
              }}
              size="small"
              variant="outlined"
            />

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button
                onClick={() => {
                  setProgress(true);
                  updateOrderWarehouse(stateWarehouse, (call) => {
                    setOpenWarehouse(false);
                    getOrderList(
                      myPc,
                      search,
                      (supplierorder) => {
                        setOrderRes(supplierorder);
                      },
                      false
                    );
                  });
                }}
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                onClick={() => setOpenWarehouse(false)}
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="xs"
        open={showAdd}
        onClose={() => setShowAdd(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <TextField
              error={errorState.productCount}
              sx={{ input: { textAlign: "center" }, width: "50%" }}
              label="تعداد سفارش"
              value={state.productCount ? state.productCount : ""}
              onChange={(evt) => {
                setState({ ...state, productCount: evt.target.value });
              }}
              size="small"
              type="number"
              variant="outlined"
            />
            <TextField
              label="توضیحات"
              multiline
              rows={3}
              value={state.description ? state.description : ""}
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              size="small"
              variant="outlined"
            />

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button
                onClick={() => {
                  if (validateEdit(state, setErrorState) == 200) {
                    setProgress(true);
                    updateOrder(state, (call) => {
                      setShowAdd(false);
                      getOrderList(
                        myPc,
                        search,
                        (supplierorder) => {
                          setOrderRes(supplierorder);
                        },
                        false
                      );
                    });
                  }
                }}
                variant="contained"
              >
                ثبت
              </Button>
              <Button onClick={() => setShowAdd(false)} variant="outlined">
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          height: "100%",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <TextField
            // fullWidth
            sx={{ width: "20%" }}
            label="جستجو"
            value={searchState}
            onChange={(evt) => {
              if (evt.target.value == "") {
                handleSearch("");
              }
              setSearchState(evt.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(searchState);
              }
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          {supplierRes ? (
            <DataGrid
              className="ltr-grid"
              disableVirtualization
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={supplierRes.pageCondition.pageCount}
              rows={supplierRes.items}
              paginationMode="server"
              page={supplierRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={supplierRes.pageCondition.totalItemCount}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  color: "primary.main",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .green": {
                  backgroundColor: "#00800033 !important",
                },
                "& .orang": {
                  backgroundColor: "#ffc36ea1 !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.state == 3) {
                  return "green";
                }
                if (params.row.state == 2) {
                  return "orang";
                }
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  newFunc: newFunc,
                  isLtr: true,
                  rowCount: supplierRes.pageCondition.totalItemCount,
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
      {open.show && (
        <OrderDetail setOpen={setOpen} open={open} orderID={open.id} />
      )}

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"سفارش"}
        callback={() => {
          setProgress(true);
          cancelOrder(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
